import { render } from "./new-service.vue?vue&type=template&id=5b1078d4"
import script from "./new-service.vue?vue&type=script&lang=js"
export * from "./new-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__